import {
  SET_CONTRACT_DETAIL,
  SET_CLIENT_DETAIL,
  SET_SUMMARY,
  SET_REPAYMENT_SCHEDULE,
  SET_TRANSACTIONS,
  SET_CONTRACT_DOCS,
  SET_CONTRACT_DOC_TYPES,
  SET_ASSET,
  SET_CONTRACT_NOTES,
  RESET,
} from './types';

export const INIT_STATE = {
  detail: {
    product: {},
    storage: {},
    agent: {},
    branch: {}
  },
  targetingContract: {
  },
  client: null,
  summary: null,
  repaymentSchedule: null,
  transactions: [],
  docs: [],
  contractDocTypes: [],
  asset: {},
  notes: [],
};

const mutations = {
  [SET_CONTRACT_DETAIL](state, contract) {
    state.targetingContract = contract;
  },
  [SET_CLIENT_DETAIL](state, result) {
    state.client = result;
  },
  [SET_SUMMARY](state, result) {
    state.summary = result;
  },
  [SET_REPAYMENT_SCHEDULE](state, result) {
    state.repaymentSchedule = result;
  },
  [SET_TRANSACTIONS](state, result) {
    state.transactions = result;
  },
  [SET_CONTRACT_DOCS](state, result) {
    state.docs = result;
  },
  [SET_CONTRACT_DOC_TYPES](state, result) {
    state.contractDocTypes = result;
  },
  [SET_ASSET](state, result) {
    state.asset = result;
  },
  [SET_CONTRACT_NOTES](state, result) {
    state.notes = [...result];
  },
  [RESET](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });
  },

};

export default mutations;
